export default __webpack_public_path__ + "static/media/gallery_02.b8f0683e.jpg";